export default __webpack_public_path__ + "static/media/Prancheta AC 1-1.b5dccf87.svg";